import {
  useQuery,
  useMutation,
  useQueryClient,
  noop
} from '@tanstack/react-query';
import * as networking from '../lib/networking';
import { RhinoContextType, RhinoRecordIdentifier } from '../index';

export const AUTH_IDENTITIES_PATH = '/api/auth/identities';
export const authIdentitiesQueryKey = ['authIdentities'];

export const useAuthIdentities = () =>
  useQuery({
    queryKey: authIdentitiesQueryKey,
    queryFn: () =>
      networking.networkApiCallOnlyData(AUTH_IDENTITIES_PATH, { method: 'get' })
  });

// Prefetch from a TanStack Router loader so connected accounts are in the React
// Query cache before <SignInSettings> mounts. The key matches useAuthIdentities,
// so the component's useQuery deduplicates and renders without a loading spinner.
export const prefetchAuthIdentities = (rhino: RhinoContextType) =>
  rhino.queryClient
    .query({
      queryKey: authIdentitiesQueryKey,
      queryFn: () =>
        networking.networkApiCallOnlyData(AUTH_IDENTITIES_PATH, {
          method: 'get'
        })
    })
    .then(noop, noop);

export const useUnlinkAuthIdentity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: RhinoRecordIdentifier) =>
      networking.networkApiCallOnlyData(`${AUTH_IDENTITIES_PATH}/${id}`, {
        method: 'delete'
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: authIdentitiesQueryKey })
  });
};
